import { createSlice } from "@reduxjs/toolkit";
import { startExamActivity } from "../../activityAsyncAction";

const initialState = {
  isFullscreen: false,
  exitFullscreenCount: 0,
};

export const fullscreenSlice = createSlice({
  name: "fullscreen",
  initialState,
  reducers: {
    setFullscreen: (state, action) => {
      state.isFullscreen = action.payload;
      if (!state.isFullscreen) {
        state.exitFullscreenCount++;
      }
    },
  },
  extraReducers: {
    [startExamActivity.fulfilled]: (state, action) => {
      //starts the exam when the activity is started
      state.isFullscreen = true;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setFullscreen } = fullscreenSlice.actions;

export default fullscreenSlice.reducer;
